module.exports = __webpack_public_path__ + "img/cs-5.fa1dbb00.png";